import ErrorTwoTone from '@mui/icons-material/ErrorTwoTone';
import Box from '@mui/material/Box';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export type Props = {
  validationErrors: string[];
};

const FormValidationSummary = ({ validationErrors }: Props) => {
  if (!validationErrors || validationErrors.length <= 0) {
    return null;
  }

  return (
    <>
      {validationErrors.map((ve) => (
        <Box key={ve} sx={{ mt: 1, display: 'flex', alignItems: 'center' }}>
          <ErrorTwoTone fontSize="small" color="error" />
          <Typography 
            variant="body2" 
            color="error" 
            sx={(theme: Theme) => ({ marginLeft: theme.spacing(1) })}
          >
            {ve}
          </Typography>
        </Box>
      ))}
    </>
  );
};

export default FormValidationSummary;
